import {
    Box,
    Chip,
    FormControlLabel,
    FormLabel,
    Grid,
    Switch,
    Tooltip,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { CategoryAutocomplete } from "../../../../../components/Form/CatetoryAutoComplete";
import ControlledAutocomplete from "../../../../../components/Form/ControlledAutocomplete";
import { CustomTextField } from "../../../../../components/Form/CustomTextField";
import { productFormFields } from "./fields";

export const FormFieldGroup = ({
    form,
    sizes,
    category,
    setCategory,
    showCategory,
    setShowCategory,
    product,
}) => {
    const fields = productFormFields(productFormFields, sizes);
    const {
        control,
        formState: { errors },
    } = form;

    return fields.map((field, index) => {
        if (field.hidden) {return null;}


        switch (field.type) {
            case "switch":
                return (
                    <Box my={3} key={field.name}>
                        <Controller
                            name={field.name}
                            control={control}
                            defaultValue={field.defaultValue ?? false}
                            render={({ field: switchField }) => (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            {...switchField}
                                            checked={switchField.value}
                                            onChange={(e) =>
                                                e.preventDefault()
                                            }
                                        />
                                    }
                                    label={field.label}
                                    labelPlacement="start"
                                />
                            )}
                        />
                    </Box>
                );

            case "text":
                return (
                    <Box my={3} key={field.name}>
                        <CustomTextField
                            label={field.label}
                            name={field.name}
                            control={control}
                            errors={errors}
                            multiline
                            required={field.required}
                            minRows={1}

                        />
                    </Box>
                );

            case "sizes":


                return (
                    <Box my={3} key="sizes">
                        <FormLabel>Available Sizesss</FormLabel>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 1,
                                my: 1,
                            }}
                        >
                            {sizes?.map?.(({ size, available }) => (
                                <Tooltip
                                    key={size}
                                    title={
                                        available ? "Available" : "Out of stock"
                                    }
                                    arrow
                                >
                                    <span>
                                        <Chip
                                            label={size}
                                            variant="outlined"
                                            color="primary"
                                            disabled={!available}
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: 25,
                                            }}
                                        />
                                    </span>
                                </Tooltip>
                            ))}
                        </Box>
                    </Box>
                );

            case "custom":
                if (field.component === "category") {
                    return (
                        <Box my={3} key="category">
                            <FormLabel>Product Category</FormLabel>
                            {/* <CustomTextField
								label="Product Category"
								name={"product_category"}
								sx={{ display: "none" }}
								control={control}
								errors={errors}
							/> */}
                            <CategoryAutocomplete
                                title="Product Category"
                                showCategory={showCategory}
                                setShowCategory={setShowCategory}
                                category={category}
                                setCategory={setCategory}
                            />
                        </Box>
                    );
                }
                return null;

            case "autocomplete":
                return (
                    <Box my={3} key={field.name}>
                        <ControlledAutocomplete
                            name={field.name}
                            label={field.label}
                            form={form}
                            rules={
                                field.required
                                    ? { required: `Select ${field.label}` }
                                    : {}
                            }
                            fetchOptions={field.fetchOptions}
                        />
                    </Box>
                );

            case "price_group":
                return (
                    <Box my={3} key="price_group">
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <CustomTextField
                                    type="number"
                                    required={true}
                                    name="discount_price"
                                    // style={{ width: "100%" }}
                                    label="Discounted Price"
                                    control={control}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CustomTextField
                                    InputProps={{
                                        inputProps: { min: 0 },
                                    }}
                                    type="number"
                                    name="original_price"
                                    label="Price"
                                    required={true}
                                    control={control}
                                    errors={errors}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                );

            default:
                return null;
        }
    });
};
